export default "__VITE_ASSET__YpxfLEDQ__"